export function getRegionFromUrl(): 'eu' | 'uk' | 'us' | null {
  const segments = window.location.pathname.split('/').filter(Boolean);
  const region = segments[0];

  if (region === 'eu' || region === 'uk' || region === 'us') {
    return region;
  }

  return null;
}

export function isSelfCo(): boolean {
  return window.location.hostname.includes('self.co');
}

/**
 * Get valid locales and default locale for a given hostname
 */
export function getLocaleConfig(hostname: string, theme: string): { validLocales: string[]; defaultLocale: string } {
  // Domain-specific configurations
  if (hostname.includes('.pl')) {
    return { validLocales: ['pl', 'en'], defaultLocale: 'pl' };
  }

  if (hostname.includes('.lt')) {
    return { validLocales: ['lt', 'en'], defaultLocale: 'lt' };
  }

  if (hostname.includes('.lv')) {
    return { validLocales: ['lv', 'en'], defaultLocale: 'lv' };
  }

  if (hostname.includes('self.co')) {
    return { validLocales: ['de', 'en', 'pl'], defaultLocale: 'de' };
  }

  // Generic domains - all locales for theme
  const themeLocales: Record<string, string[]> = {
    selfCo: ['de', 'en', 'pl'],
    allergomedica: ['lt', 'pl', 'lv', 'en'],
    foodId: ['lt', 'pl', 'lv', 'en'],
  };

  const validLocales = themeLocales[theme] || ['en'];
  const defaultLocale = theme === 'selfCo' ? 'de' : 'lt';

  return { validLocales, defaultLocale };
}
